const plans = (products, orders, isActive)=>{
  let keyMap={
    DESCRIPTION:"desc",
    INVOICE_PRODCUT_CODE: "pricePlanId",
    OPTIONS:"options",
    PLAN:"plan",
    PLAN_ID:"planId",
    PRICE_PLAN:"pricePlan",
    TITLE:"title",
    ICON:"icon",
    PRICE:"price",
    STROKEWIDTH:"strokeWidth",
    CURRENCY:"currency",
    ACTIVE:"active"
  }
  const sortedProducts = Object.entries(products)
  .sort(([keyA], [keyB]) => {
    const orderA = orders[keyA] ?? Infinity;
    const orderB = orders[keyB] ?? Infinity;
    return orderA - orderB;
  })
  return sortedProducts.map(
    ([key, product])=>{
        const active = isActive[key] ?? false;
      return {
        [keyMap["TITLE"]]:product["TITLE"],
        [keyMap["DESCRIPTION"]]:product["DESCRIPTION"],
        [keyMap["INVOICE_PRODCUT_CODE"]]:product["INVOICE_PRODCUT_CODE"],
        [keyMap["PRICE_PLAN"]]:product["PRICE_PLAN"],
        [keyMap["PLAN"]]:product["PLAN"],
        [keyMap["PLAN_ID"]]:product["PLAN_ID"],
        [keyMap["PRICE"]]:[
          product.PRICE["CURRENCY"], product.PRICE["PRICE"], product.PRICE["UNIT"]
        ],
        [keyMap["ACTIVE"]]:active,
        [keyMap["OPTIONS"]]: Object.values(product["OPTIONS"]).map(
          (option)=>{
            let {ICON, INFO, STROKEWIDTH} = option;
            return {
              icon:ICON,
              info:INFO,
              strokeWidth:STROKEWIDTH
            }
          }
        )
      }
    }
  )
  
  
  // return [
  //   {
  //     "title": "Individual Minimalist",
  //     "desc": "Freemium Subscription",
  //     "price": ["$", "0", "month"],
  //     "pricePlan":"Individual Minimalist Freemium",
  //     "plan":"Individual Minimalist",
  //     "planId": "INDIVIDUAL_MINALIST",
  //     "pricePlanId":priceplanIds.INDIVIDUAL_MINALIST_FREE,
  //     "options": [
  //       { "icon": "CheckCircleIcon", "info": "Manage Credentials" },
  //       { "icon": "CheckCircleIcon", "info": "Manage Accounts" },
  //       { "icon": "MinusCircleIcon", "info": "Manage Contacts", "strokeWidth":"2.5" },
  //       { "icon": "MinusCircleIcon", "info": "Manage Groups", "strokeWidth":"2.5"},
  //       { "icon": "CheckCircleIcon", "info": "Searches" },
  //       { "icon": "MinusCircleIcon", "info": "Data Sharing", "strokeWidth":"2.5" }
  //     ]
  //   },
  //   {
  //     "title": "Individual Plus",
  //     "desc": "Individual Plus Monthly Subscription",
  //     "price": ["$4", "", "month"],
  //     "pricePlan":"Individual Plus Monthly",
  //     "plan":"Individual Plus",
  //     "planId": "INDIVIDUAL_PLUS",
  //     "pricePlanId":priceplanIds.INDIVIDUAL_PLUS_MONTHLY,
  //     "options": [
  //       { "icon": "CheckCircleIcon", "info": "Manage Credentials" },
  //       { "icon": "CheckCircleIcon", "info": "Manage Accounts" },
  //       { "icon": "CheckCircleIcon", "info": "Manage Contacts" },
  //       { "icon": "MinusCircleIcon", "info": "Manage Groups", "strokeWidth":"2.5" },
  //       { "icon": "CheckCircleIcon", "info": "Searches" },
  //       { "icon": "MinusCircleIcon", "info": "Data Sharing", "strokeWidth":"2.5" }
  //     ]
  //   },
  //   {
  //     "title": "Individual Plus",
  //     "desc": "Individual Plus Yearly Subscription Plan ",
  //     "price": ["$36", "", "year ($3/month)"],
  //     "pricePlan":"Individual Plus Yearly",
  //     "plan":"Individual Plus",
  //     "planId": "INDIVIDUAL_PLUS",
  //     "pricePlanId":priceplanIds.INDIVIDUAL_PLUS_YEARLY,
  //     "options": [
  //       { "icon": "CheckCircleIcon", "info": "Manage Credentials" },
  //       { "icon": "CheckCircleIcon", "info": "Manage Accounts" },
  //       { "icon": "CheckCircleIcon", "info": "Manage Contacts" },
  //       { "icon": "MinusCircleIcon", "info": "Manage Groups", "strokeWidth":"2.5" },
  //       { "icon": "CheckCircleIcon", "info": "Searches" },
  //       { "icon": "MinusCircleIcon", "info": "Data Sharing", "strokeWidth":"2.5" }
  //     ]
  //   },
  //   {
  //     "title": "Individual Freedom",
  //     "desc": "Individual Freedom Monthly Subscription Plan",
  //     "price": ["$6.25", "", "month"],
  //     "pricePlan":"Individual Freedom Monthly",
  //     "plan":"Individual Freedom",
  //     "planId": "INDIVIDUAL_FREEDOM",
  //     "pricePlanId":priceplanIds.INDIVIDUAL_FREEDOM_MONTHLY,
  //     "options": [
  //       { "icon": "CheckCircleIcon", "info": "Manage Credentials" },
  //       { "icon": "CheckCircleIcon", "info": "Manage Accounts" },
  //       { "icon": "CheckCircleIcon", "info": "Manage Contacts" },
  //       { "icon": "CheckCircleIcon", "info": "Manage Groups" },
  //       { "icon": "CheckCircleIcon", "info": "Searches" },
  //       { "icon": "MinusCircleIcon", "info": "Data Sharing", "strokeWidth":"2.5" }
  //     ]
  //   },

  //   {
  //     "title": "Individual Freedom",
  //     "desc": "Individual Freedom Yearly Subscription Plan",
  //     "price": ["$60", "", "year ($5/month)"],
  //     "pricePlan":"Individual Freedom Yearly",
  //     "plan":"Individual Freedom",
  //     "planId": "INDIVIDUAL_FREEDOM",
  //     "pricePlanId":priceplanIds.INDIVIDUAL_FREEDOM_YEARLY,
  //     "options": [
  //       { "icon": "CheckCircleIcon", "info": "Manage Credentials" },
  //       { "icon": "CheckCircleIcon", "info": "Manage Accounts" },
  //       { "icon": "CheckCircleIcon", "info": "Manage Contacts" },
  //       { "icon": "CheckCircleIcon", "info": "Manage Groups" },
  //       { "icon": "CheckCircleIcon", "info": "Searches" },
  //       { "icon": "MinusCircleIcon", "info": "Data Sharing", "strokeWidth":"2.5" }
  //     ]
  //   }
    
  // ]
}

export default plans;